import { DATA_AGE_TYPES } from "../data/options";

export function providerAgeTypeLabel(provider) {
  if (!provider || typeof provider !== "object") return null;
  const ageType = provider.ageType || "PREVIOUS";
  const match = DATA_AGE_TYPES.find((item) => item.value === ageType);
  return (match?.label || ageType).trim();
}
